export default "__VITE_ASSET__6be7d54f__"